<div class="custom-imports__form-card surface-card">
  <div class="custom-imports__form-header">
    <div>
      <h2>{{ formTitleKey | translate }}</h2>
      <p>{{ 'customImports.form.description' | translate }}</p>
    </div>
    <button type="button"
            class="ghost-btn compact"
            (click)="cancel()"
            aria-label="{{ 'customImports.actions.close' | translate }}">×</button>
  </div>

  <form class="custom-imports__form" [formGroup]="customImportForm" (ngSubmit)="submit()">
    <div class="form-field" *ngIf="advanced && mode === 'edit' && customImportForm.value.id">
      <span>ID</span>
      <div class="custom-imports__id-row">
        <code>{{ customImportForm.value.id }}</code>
        <button type="button" class="ghost-btn compact" (click)="copyId()">
          {{ (copied ? 'common.copied' : 'common.copy') | translate }}
        </button>
      </div>
    </div>

    <div class="form-field" *ngIf="hasGlobalDataScope">
      <span>Owner</span>
      <app-custom-select
        formControlName="ownerEntitySelect"
        [options]="ownerEntityOptions"
        placeholder="Seleziona un'entità">
      </app-custom-select>
      <small class="field-error"
             *ngIf="customImportForm.get('ownerEntitySelect')?.invalid && customImportForm.get('ownerEntitySelect')?.touched">
        Seleziona un owner
      </small>
    </div>

    <label class="form-field">
      <span>{{ 'customImports.form.name' | translate }}</span>
      <input type="text" formControlName="name" [placeholder]="'customImports.form.namePlaceholder' | translate">
    </label>

    <label class="form-field">
      <span>{{ 'customImports.form.exportIdType' | translate }}</span>
      <app-custom-select
        formControlName="exportIdType"
        [options]="exportIdTypeOptions"
        [placeholder]="'customImports.form.select' | translate">
      </app-custom-select>
    </label>

    <!-- Generated ingestion folder: read-only, known only once the custom import exists. -->
    <div class="form-field" *ngIf="mode === 'edit' && initialValue?.storagePath">
      <span>{{ 'customImports.form.storagePath' | translate }}</span>
      <div class="custom-imports__id-row">
        <code>{{ initialValue?.storagePath }}</code>
        <button type="button" class="ghost-btn compact" (click)="copyStoragePath()">
          {{ (copiedPath ? 'common.copied' : 'common.copy') | translate }}
        </button>
      </div>
      <small class="file-upload-hint">{{ 'customImports.form.storagePathHint' | translate }}</small>
    </div>

    <div class="form-field">
      <span>{{ 'customImports.form.fileUpload' | translate }}</span>
      <small class="file-upload-hint">{{ 'customImports.form.fileUploadHint' | translate }}</small>

      <div class="file-upload-zone"
           [class.disabled]="!customImportForm.value.exportIdType"
           [class.has-file]="selectedFile"
           (click)="!customImportForm.value.exportIdType || fileInput.click()"
           (dragover)="onDragOver($event)"
           (dragleave)="onDragLeave($event)"
           (drop)="onDrop($event)">

        <input type="file"
               accept=".csv,.txt,.tsv,.xls,.xlsx"
               (change)="handleFileSelected($event)"
               [disabled]="!customImportForm.value.exportIdType"
               #fileInput
               hidden>

        <div *ngIf="!selectedFile" class="upload-prompt">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
            <polyline points="17 8 12 3 7 8"></polyline>
            <line x1="12" y1="3" x2="12" y2="15"></line>
          </svg>
          <p class="upload-main-text">{{ 'customImports.form.dropFileHint' | translate }}</p>
          <button type="button" class="upload-button" [disabled]="!customImportForm.value.exportIdType">
            Upload
          </button>
        </div>

        <div *ngIf="selectedFile" class="file-info">
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path>
            <polyline points="13 2 13 9 20 9"></polyline>
          </svg>
          <span class="file-name">{{ selectedFile.name }}</span>
        </div>
      </div>

      <div class="file-upload-progress-bar" *ngIf="uploadProgress > 0" [style.--percent]="uploadProgress + '%'"></div>
      <small class="field-error" *ngIf="fileError">{{ fileError }}</small>
      <small *ngIf="!customImportForm.value.exportIdType" class="field-hint">
        {{ 'customImports.form.selectIdTypeFirst' | translate }}
      </small>
    </div>

    <div class="form-actions">
      <button type="button" class="ghost-btn" (click)="cancel()" [disabled]="saving || uploading">
        {{ 'customImports.actions.cancel' | translate }}
      </button>
      <button type="submit" class="primary-btn" [disabled]="saving || uploading">
        {{ mode === 'edit'
            ? ('customImports.actions.save' | translate)
            : ('customImports.actions.import' | translate) }}
      </button>
    </div>
  </form>

  <div class="upload-progress" *ngIf="uploading">
    <span>Uploading file... {{ uploadProgress }}%</span>
  </div>
</div>
